import router from "@/router";
import store from "@/store";
import Cookies from "@/utils/Cookies";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from cookie

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login", "/userRegister", "/forget"]; //  不需要重定向的

router.beforeEach((to, from, next) => {
  // 载入进度条开始
  NProgress.start();
  document.title = "理菜宝-" + to.meta.title;
  // 获取token
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === "/login") {
      // 如果已经登陆，重定向到首页
      next({ path: "/" });
      NProgress.done(); // 载入进度结束
    } else {
      // 设置replace: true，这样导航就不会留下历史记录
      if (to.name == "i") {
        var res_z = JSON.parse(Cookies.get("rule"));
        if (res_z.includes("1") && !res_z.includes("2")) {
          next("/openOrder/order");
        } else if (res_z.includes("2")) {
          next("/openOrder/orderCheckOut");
        } else {
          next("/openOrder/order");
        }
      } else {
        next();
      }
      NProgress.done(); // 载入进度结束
      next();
      // next({ ...to, replace: true })
    }
  } else {
    /* 没有token 登录*/
    if (whiteList.indexOf(to.path) > -1) {
      // 如果是不需要登录的页面，不用跳转
      next();
    } else {
      // 记录下来是从哪个页面跳到登录的，登录完成后重新跳回去.
      next(`/login?redirect=${to.path}`);
      NProgress.done(); // 载入进度结束
    }
  }
});

router.afterEach((to, from, next) => {
  // 载入进度结束
  NProgress.done();
});
